// extracted by mini-css-extract-plugin
export var active_res_type = "index-module--active_res_type--Vmd3m";
export var bodyFont = "index-module--body-font--U7L3V";
export var borderRadius = "index-module--border-radius--V5c-W";
export var clearButtonStyles = "index-module--clear-button-styles--5gtji";
export var res_type_wrapper = "index-module--res_type_wrapper--21LnA";
export var titleFont = "index-module--title-font--FS8CM";